import { Grid } from 'antd';

const { useBreakpoint } = Grid;

// Sync check for initial render (useBreakpoint returns {} on first render)
const getInitialMobile = () => typeof window !== 'undefined' && window.innerWidth < 992;

export const useView = () => {
  const screens = useBreakpoint();

  // useBreakpoint returns {} on the first render before media queries fire.
  // Fall back to window.innerWidth so the initial render is correct.
  const hasResolved = Object.keys(screens).length > 0;

  // Mobile: below lg (< 992px) — tablets use mobile layouts
  // Desktop: lg and above (≥ 992px)
  // SmallDesktop: lg but not xl (992px–1199px) — smaller laptops
  const isMobile = hasResolved ? !screens.lg : getInitialMobile();
  const isSmallDesktop = hasResolved ? !!screens.lg && !screens.xl : false;
  const isDesktop = hasResolved ? !!screens.lg : !getInitialMobile();

  return { isMobile, isSmallDesktop, isDesktop, screens };
};
